module.exports = __webpack_public_path__ + "img/KSC02795.f80c0ade.jpg";